import { Close as CloseIcon } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import type React from 'react';
import { useEffect, useState } from 'react';

export const ImagePreview: React.FC<{ file: File; onRemove: () => void }> = ({
  file,
  onRemove,
}) => {
  const [objectUrl, setObjectUrl] = useState<string>('');

  useEffect(() => {
    const url = URL.createObjectURL(file);
    setObjectUrl(url);
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  return (
    <Box sx={{ position: 'relative', width: 100, height: 100 }}>
      {objectUrl && (
        <img
          src={objectUrl}
          alt={file.name}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: 4,
          }}
        />
      )}
      <IconButton
        aria-label={`Remove attachment ${file.name}`}
        size="small"
        sx={{
          position: 'absolute',
          top: -8,
          right: -8,
          backgroundColor: 'background.paper',
          '&:hover': { backgroundColor: 'grey.300' },
          boxShadow: 1,
        }}
        onClick={onRemove}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
